module.exports = __webpack_public_path__ + "img/selection-field.d410589e.svg";